import store from '@/store/store'

class AnalyticsModule {

  getOutcomes = () => store.state.analytics.outcomes

  getAggregatedAutomationOutcomes = () => store.state.analytics.aggregatedAutomationOutcomes

  getAssistanceResolutions = () => store.state.analytics.assistanceResolutions

  getIntentUsages = () => store.state.analytics.intentUsages

  getRequestTotal = () => store.state.analytics.requestTotal

  getContactTotal = () => store.state.analytics.contactTotal

  getRequests = () => store.state.analytics.requests

  getContacts = () => store.state.analytics.contacts

  setOutcomes(requestOutcomes) {
    store.commit('ANALYTICS_OUTCOMES_SET', requestOutcomes)
  }

  setRequestTotal(requestTotal) {
    store.commit('ANALYTICS_REQUEST_TOTAL_SET', requestTotal)
  }

  setContactTotal(contactTotal) {
    store.commit('ANALYTICS_CONTACT_TOTAL_SET', contactTotal)
  }

  setAggregatedAutomationOutcomes(aggregatedAutomationOutcomes) {
    store.commit('ANALYTICS_AGGREGATED_AUTOMATION_OUTCOMES_SET', aggregatedAutomationOutcomes)
  }

  setAssistanceResolutions(assistanceResolutions) {
    store.commit('ANALYTICS_ASSISTANCE_RESOLUTIONS_SET', assistanceResolutions)
  }

  setIntentUsages(intentUsages) {
    store.commit('ANALYTICS_INTENT_USAGES_SET', intentUsages)
  }

  setRequests(requests) {
    store.commit('ANALYTICS_REQUESTS_SET', requests)
  }

  setContacts(contacts) {
    store.commit('ANALYTICS_CONTACTS_SET', contacts)
  }
}

export default new AnalyticsModule()
